import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {appConfig} from "./app-config";
import {OrganizationTreeSelect} from "./dip/organization-tree-select";
import {DOCUMENT} from "@angular/common";
import {AuthenticationService} from "./services/authentication.service";
import {User} from "./models/user";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  user: User = this.authenticationService.currentUserValue;

  constructor(private organizationTreeSelect: OrganizationTreeSelect, @Inject(DOCUMENT) private document: Document, private authenticationService: AuthenticationService) {
    document.documentElement.style.setProperty('--toolbar-bg-color', appConfig.header_navbar_bg_color);
    document.documentElement.style.setProperty('--toolbar-text-color', appConfig.header_navbar_text_color);
    document.documentElement.style.setProperty('--grid-header-bg-color', appConfig.grid_header_footer_bg_color);
    document.documentElement.style.setProperty('--grid-header-text-color', appConfig.grid_header_footer_text_color);
    document.documentElement.style.setProperty('--grid-highlight-bg-color', appConfig.grid_highlight_row_bg_color);
    organizationTreeSelect.subscribe();
  }

  ngOnInit() {
    this.document.documentElement.lang = navigator.language;
  }

  ngOnDestroy(): void {
    this.organizationTreeSelect.unsubscribe();
  }
}
